<template>
  <cus-header
    class="main-container"
    :text-img="require('@/assets/main/head_title_text.png')"
  >
    <div class="main-body">
      <div class="mb-second">
        <div class="mb-notice bounceInLeft animated">
          <img
            class="mb-notice-bg"
            src="../../assets/main/bg_gongzuodongtai.png"
            alt=""
          />
          <div class="mb-notice-header">
            <div class="mbnh-til">工作动态</div>
            <!-- @click="Goto('/news')" -->
            <div class="mbnh-more">
              <!-- 更多 <i class="el-icon-arrow-right"></i> -->
            </div>
          </div>
          <!-- @click="Goto('/newsDetail')" -->
          <div class="mb-notice-body">
            <div class="mb-notice-cell">
              <div class="left">
                关于进一步做好基础学科高水平人才培养基地建设和地方高校“101计划”试点推进及增补工作...
              </div>
              <div class="right">2024-06-03</div>
            </div>
            <div class="mb-notice-cell">
              <div class="left">
                教育厅关于组织开展首批省级基础学科高水平培养基地建设方案编制工作的通知
              </div>
              <div class="right">2024-06-03</div>
            </div>
            <div class="mb-notice-cell">
              <div class="left">全面推进“一〇一计划” 筑基拔尖创新人才培养</div>
              <div class="right">2024-06-03</div>
            </div>
            <div class="mb-notice-cell">
              <div class="left">
                关于开展基础学科和“四新” 关键领域本科教育教学改革试点工作
                （地方高校“101计划”）...
              </div>
              <div class="right">2024-06-03</div>
            </div>
            <div class="mb-notice-cell">
              <div class="left">
                关于组织参加2024年大学生新文科实践创新大赛的通知
              </div>
              <div class="right">2024-06-03</div>
            </div>
            <div class="mb-notice-cell">
              <div class="left">
                关于组织参加2024年大学生新文科实践创新大赛的通知
              </div>
              <div class="right">2024-06-03</div>
            </div>
            <div class="mb-notice-cell">
              <div class="left">
                关于组织参加2024年大学生新文科实践创新大赛的通知
              </div>
              <div class="right">2024-06-03</div>
            </div>
          </div>
        </div>
        <div class="mb-card bounceInRight animated">
          <div class="mb-card-header">
            <div class="mbch-til">平台数据</div>
            <div></div>
          </div>
          <div class="mb-card-body">
            <div class="item_list">
              <div
                class="mb-card-body_item"
                v-for="(item, index) in PTdata"
                :key="index"
                :style="{ background: item.background }"
              >
                <div class="item_img">
                  <img :src="item.icon" alt="" />
                </div>
                <div class="title">
                  <div class="label">{{ item.name }}</div>
                  <div class="number">{{ item.num }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-group">
        <div class="mb-card bounceInRight animated">
          <div class="mb-card-header">
            <div class="mbch-til">业务平台</div>
            <div></div>
          </div>
          <div class="mb-card-body">
            <div class="mb-card-first">
              <div
                class="mb-card-first-item"
                v-for="(item, index) in systemList"
                :key="index"
                @click="jump(item.path, item.name)"
              >
                <div>
                  <div class="icon">
                    <img :src="item.icon" alt="" />
                  </div>
                  <div class="label">
                    <span v-if="!item.isLine">{{ item.name }}</span>
                    <span v-else>{{item.name.slice(0,-4)}}<br/>{{ item.name.slice(item.name.length-4, item.name.length) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </cus-header>
</template>

<script>
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      PTdata: [
        {
          name: "示范中心数量（个）",
          icon: require("@/assets/main/icon_shifan.png"),
          num: "88",
          background: "linear-gradient(-55deg, #E5F3FF 0%, #FFFFFF 100%)",
        },
        {
          name: "虚拟仿真中心数量（个）",
          icon: require("@/assets/main/icon_xuni.png"),
          num: "65",
          background: "linear-gradient(-55deg, #FFF8DE 0%, #FFFFFF 100%)",
        },
        {
          name: "实验教学项目数量（个）",
          icon: require("@/assets/main/icon_jiaoxue.png"),
          num: "468",
          background: "linear-gradient(-55deg, #F1E9FF 0%, #FFFFFF 100%)",
        },
        {
          name: "实验室数量（个）",
          icon: require("@/assets/main/icon_shiyanshi.png"),
          num: "13797",
          background: "linear-gradient(-55deg, #DEFFFF 0%, #FFFFFF 100%)",
        },
        {
          name: "新文科大赛参与团队（组）",
          icon: require("@/assets/main/icon_xinwenke.png"),
          num: "3369",
          background: "linear-gradient(-55deg, #FFE5E7 0%, #FFFFFF 100%)",
        },
        {
          name: "大学生实习人数（人）",
          icon: require("@/assets/main/icon_daxuesheng.png"),
          num: "10583",
          background: "linear-gradient(-55deg, #E9FFEB 0%, #FFFFFF 100%)",
        },
      ],
      systemList: [
        {
          name: "实验教学示范中心管理平台",
          icon: require("@/assets/main/icon_jiaoxue(1).png"),
          path: "http://122.51.76.10:8088/",
          isLine:true
        },
        {
          name: "虚拟仿真实验中心管理平台",
          icon: require("@/assets/main/icon_xuni(1).png"),
          path: "",
          isLine:true
        },
        {
          name: "高校实验室安全管理平台",
          icon: require("@/assets/main/icon_anquan.png"),
          path: "http://122.51.76.10:8090/",
          isLine:true
        },

        {
          name: "大学生实习管理平台",
          icon: require("@/assets/main/icon_shixi.png"),
          path: "",
          isLine:false
        },
        {
          name: "实验室智慧管理平台",
          icon: require("@/assets/main/icon_zhihuiguanli.png"),
          path: "",
          isLine:false
        },
        {
          name: "实验课程管理平台",
          icon: require("@/assets/main/icon_kecheng.png"),
          path: "http://122.51.76.10:8084/",
          isLine:false
        },

        {
          name: "规划教材管理平台",
          icon: require("@/assets/main/icon_jiaocai.png"),
          path: "http://122.51.76.10:8083/",
          isLine:false
        },

        {
          name: "本科毕业论文项目管理平台",
          icon: require("@/assets/main/icon_lunwen.png"),
          path: "http://122.51.76.10:8082/",
          isLine:true
        },
        {
          name: "实验教学和教学实验室建设研究项目管理",
          icon: require("@/assets/main/icon_lunwen.png"),
          path: "http://122.51.76.10:8082/",
          isLine:false
        },
        {
          name: "新文科实践创新大赛管理平台",
          icon: require("@/assets/main/icon_dasai.png"),
          path: "http://122.51.76.10:8086/",
          isLine:true
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    jump(url, name) {
      if (url) {
        window.open(url);
      } else {
        this.handleTips(`${name}暂未开通`);
      }
    },
    Goto(path) {
      this.$router.push(path);
    },
    handleTips(text) {
      this.$alert(text, "提示", {
        confirmButtonText: "确定",
        callback: (action) => {},
      });
    },
   
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-color: #edf6fa;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
  }

  .main-header {
    position: relative;
    z-index: 2;

    .header-con {
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      padding: 0 1.5625vw;

      .logo {
        width: 3vw;
        height: 3vw;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.625vw;
      }

      .main-title {
        height: 2.447916vw;

        img {
          width: auto;
          height: 100%;
        }
      }
    }
  }

  .main-body {
    padding: 1.04166vw;
    height: 0;
    flex-grow: 1;
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;

    .mb-group {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 1.0416666666vw;

      .mb-card {
        flex-grow: 1;
        width: 0;
        height: 100%;
        background: rgba(255, 255, 255, 0.5);
        box-shadow: 0px 0.15625vw 0.052083vw 0px rgba(255, 255, 255, 0.6),
          0px -0.260416vw 0.052083vw 0px rgba(255, 255, 255, 0.6),
          3.6458vw -0.10416666vw 11.71875vw 1.30208vw rgba(255, 255, 255, 0.34);
        border-radius: 0.52083vw;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;

        .mb-card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 3.33333vw;
          padding: 0 1.0416666666vw;
          border-bottom: 0.052083vw solid #cee2f1;
          position: relative;
          z-index: 2;
          box-sizing: border-box;

          .mbch-til {
            font-size: 1.0416666666vw;
            font-weight: bold;
            padding-left: 1.0416666666vw;
            position: relative;
          }

          .mbch-til::after {
            content: "";
            display: block;
            position: absolute;
            height: 1.0416666666vw;
            width: 0.20833333vw;
            background-color: #006cff;
            left: 0;
            top: 50%;
            margin-top: -0.520833333vw;
          }
        }

        .mb-card-body {
          flex-grow: 1;
          padding: 1.0416666666vw;
          display: flex;
          flex-direction: column;
          .mb-card-first {
            flex-grow: 1;
            display: flex;
            justify-content: space-between;

            .mb-card-first-item {
              width: calc((100% - 6.0833333vw) / 10);
              height: 100%;
              box-shadow: 0px 0px 0.52083vw 0px rgba(109, 164, 255, 0.35);
              border-radius: 0.52083vw;
              padding: 1.12411121vw 0;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              transition: all 0.5s, background-color 1s ease;
              background-image: linear-gradient(to bottom, white, #fff);

              .icon {
                width: 3.90625vw;
                margin: 0 auto;
                margin-bottom: 0.5vw;
              }

              .label {
                font-weight: bold;
                font-size: 0.85vw;
                padding: 0 0.4vw;
                height: 50px;
                text-align: center;
              }
            }

            .mb-card-first-item:hover {
              transform: scale(1.1);
              background-image: linear-gradient(to bottom, white, #c5f7fe);
            }
          }
        }
      }
    }

    .mb-second {
      flex-grow: 1;
      height: 0;
      display: flex;

      .mb-notice {
        box-shadow: 0px 0px 0.52083vw 0px rgba(109, 164, 255, 0.35);
        border-radius: 0.52083vw;
        border: 0.15625vw solid #ffffff;
        height: 100%;
        width: 38.4375vw;
        margin-right: 1.0416666666vw;
        display: flex;
        flex-direction: column;
        position: relative;

        .mb-notice-bg {
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 1;
          left: 0;
          top: 0;
        }

        .mb-notice-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 3.33333vw;
          padding: 0 1.0416666666vw;
          border-bottom: 0.052083vw solid #cee2f1;
          position: relative;
          z-index: 2;

          .mbnh-til {
            font-size: 1.0416666666vw;
            font-weight: bold;
            padding-left: 1.0416666666vw;
            position: relative;
          }

          .mbnh-til::after {
            content: "";
            display: block;
            position: absolute;
            height: 1.0416666666vw;
            width: 0.20833333vw;
            background-color: #006cff;
            left: 0;
            top: 50%;
            margin-top: -0.520833333vw;
          }

          .mbnh-more {
            color: #999999;
            cursor: pointer;
          }
        }

        .mb-notice-body {
          height: 0;
          flex-grow: 1;
          position: relative;
          z-index: 2;
          overflow-y: auto;

          .mb-notice-cell {
            height: 14.2857142%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 1.0416666666vw;
            border-bottom: 0.052083vw solid #ccc;
            min-height: 3.125vw;

            .left {
              position: relative;
              padding-left: 1.0416666666vw;
              margin-right: 1.0416666666vw;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              flex-grow: 1;
              width: 0;
              cursor: pointer;
            }

            .left::after {
              content: "";
              display: block;
              position: absolute;
              width: 0.4166666vw;
              height: 0.4166666vw;
              border-radius: 50%;
              background-color: #b7b7b7;
              top: 50%;
              margin-top: -0.20833333vw;
              left: 0;
            }

            .right {
              color: #666666;
            }
          }

          & .mb-notice-cell:last-child {
            border-bottom: 0 none;
          }

          .mb-notice-cell:hover .left {
            color: #006cff;
          }

          .mb-notice-cell:hover .right {
            color: #006cff;
          }

          .mb-notice-cell:hover .left::after {
            background-color: #006cff;
          }
        }
      }

      .mb-card {
        flex-grow: 1;
        width: 0;
        height: 100%;
        background: rgba(255, 255, 255, 0.4);
        box-shadow: 0px 0.15625vw 0.052083vw 0px rgba(255, 255, 255, 0.6),
          0px -0.260416vw 0.052083vw 0px rgba(255, 255, 255, 0.6),
          3.6458vw -0.10416666vw 11.71875vw 1.30208vw rgba(255, 255, 255, 0.34);
        border-radius: 0.52083vw;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;

        .mb-card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 3.33333vw;
          padding: 0 1.0416666666vw;
          border-bottom: 0.052083vw solid #cee2f1;
          position: relative;
          z-index: 2;
          box-sizing: border-box;

          .mbch-til {
            font-size: 1.0416666666vw;
            font-weight: bold;
            padding-left: 1.0416666666vw;
            position: relative;
          }

          .mbch-til::after {
            content: "";
            display: block;
            position: absolute;
            height: 1.0416666666vw;
            width: 0.20833333vw;
            background-color: #006cff;
            left: 0;
            top: 50%;
            margin-top: -0.520833333vw;
          }
        }

        .mb-card-body {
          height: 0;
          flex-grow: 1;
          padding: 1.0416666666vw;
          display: flex;
          flex-direction: column;
          .item_list {
            flex-grow: 1;
            height: 0;
            z-index: 2;
            overflow: auto;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;

            .mb-card-body_item {
              width: 17vw;
              margin: 0.5vw;
              height: 43%;
              min-height: 5.55555vw;
              border-radius: 1vw;
              border: 0.222222vw solid #ffffff;
              padding: 0.788vw;
              display: flex;
              align-items: center;
              .item_img {
                width: 4.34444vw;
              }
              .title {
                color: #333333;
                margin-left: 0.520833333vw;
                padding-left: 0.520833333vw;
                .label {
                  font-family: Source Han Sans CN;
                  font-weight: 500 !important;
                  font-size: 0.8416666666vw;

                  color: #333333;
                }
                .number {
                  font-family: Arial;
                  font-weight: bold;
                  font-size: 1.34123321vw;
                  margin-top: 1vw;
                  color: #333333;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 922px) {
  .main-container {
    width: 100%;
    overflow-y: auto;
    font-size: 16px !important;
    .main-body {
      padding: 15px;
      height: 100%;
      .mb-second {
        display: flex;
        flex-direction: column;
        .mb-notice {
          width: 100%;
          .mb-notice-header {
            height: auto;
            padding: 10px;
            .mbnh-til {
              font-size: 16px;
              padding-left: 10px;
            }
            .mbnh-til::after {
              height: 16px;
              width: 3px;
              top: 30%;
            }
          }
          .mb-notice-body {
            .mb-notice-cell {
              min-height: 40px;
              margin: 0 10px;
              .left {
                padding-left: 10px;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                margin-right: 10px;
              }
              .left::after {
                width: 5px;
                height: 5px;
              }
              .right {
                font-size: 12px;
              }
            }
          }
        }
        .mb-card {
          width: 100%;
          margin-top: 10px;
          height: 470px;
          .mb-card-header {
            height: auto;
            padding: 10px;

            .mbch-til {
              font-size: 16px;
              padding-left: 10px;
            }
            .mbch-til::after {
              height: 16px;
              width: 3px;
              top: 30%;
            }
          }
          .mb-card-body {
            padding: 10px;
            height: 100%;
            .item_list {
              width: 100%;
              height: auto;
              flex-grow: 0;
              .mb-card-body_item {
                width: 48%;
                height: 70px;
                padding: 8px;
                .item_img {
                  width: 45px;
                }
                .title {
                  margin-left: 5px;
                  padding-left: 5px;
                  .label {
                    font-size: 11px;
                  }
                  .number {
                    font-size: 16px;
                  }
                }
              }
            }
          }
        }
      }
      .mb-group {
        padding-top: 10px;
        .mb-card {
          width: 100%;
          height: 170px;
          .mb-card-header {
            height: auto;
            padding: 10px;

            .mbch-til {
              font-size: 16px;
              padding-left: 10px;
            }
            .mbch-til::after {
              height: 16px;
              width: 3px;
              top: 30%;
            }
          }
          .mb-card-body {
            padding: 10px;
            height: 100%;
            flex-grow: 0;
            .mb-card-first {
              width: 100%;
              height: 100%;
              flex-grow: 0;
              overflow-x: auto;
              .mb-card-first-item {
                width: 120px;
                padding: 0 10px;
                margin: 0 5px;
                border-radius: 5px;
                .icon {
                  width: 100px;
                  padding: 0 20px;
                }
                .label {
                  font-size: 12px;
                  height: 32px;
                  text-align: center;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>